export {FocusScreen as default} from "@features/swing-trading/screens";
